import { SelectProps } from 'antd';
import { useMemo, VFC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { MeterAccessibility } from '@enmon/commons/lib/enmon';
import { Select } from './Select';
import { SelectMessages as messages } from './messages';
import { filterOption } from './utils';
import { accessibilityTranslated } from '../Form/meter_details/constants';

export const AccessibilitySelect: VFC<SelectProps> = props => {
  const intl = useIntl();

  const options = useMemo(() => {
    return Object.values(MeterAccessibility).map(accessibility => ({
      label: intl.formatMessage(accessibilityTranslated[accessibility]),
      value: accessibility,
    }));
  }, [intl]);

  return (
    <Select
      allowClear
      showSearch
      className="w-100"
      filterOption={filterOption}
      mode="multiple"
      options={options}
      placeholder={<FormattedMessage {...messages.accessibilityPlaceholder} />}
      {...props}
    />
  );
};
